import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RestUrlsConfig } from '@signature-it/ngx-generic/config';
import { LanguageService } from '@signature-it/ngx-generic/services';
import { EntityTreeService } from '@signature-it/ngx-entity/services';
import { Observable , throwError } from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {Group} from '@signature-it/ngx-catalogue/models';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    constructor (
        protected http: HttpClient,
        protected restUrlsConfig: RestUrlsConfig,
        protected langSvc: LanguageService,
        protected entityTreeService: EntityTreeService) {}


    getNavigation(depth, group?, taxonomyUri?, entityVar?): Observable<any[]> {
        const currLang = this.langSvc.getCurrentLanguage();
        if (!group) {
            group = '1';
        }
        if (isNaN(parseInt(group))) {
            return throwError('');
        }
        if (!entityVar) {
            return this.http.get<any[]>(`${this.restUrlsConfig.appURL}/public/group/${group}/groupTree.json?depth=${depth}&lang=${currLang.code}`)
                .pipe(tap ((res) => {
                    res['data'] = new Group(res['data'], true);
                    return res;
                }, (error) => throwError(error)));
        }

        return this.entityTreeService.getTreeByTaxUri(depth, taxonomyUri, entityVar).pipe(map((res) => {
            const response = [];
            res[0]['taxonomyUri'] = taxonomyUri;
            response['data'] = new Group(res[0], true);
            return response;
        }), catchError((error: any) => throwError(error)));
    }

    getGroupForSlug(groupSlug) {
        return this.http.get(`${this.restUrlsConfig.appURL}/public/group?slug=${groupSlug}`)
            .pipe(map((res) => {
                return res[0].id;
            }), catchError(error =>  throwError(error)));
    }

}

